module.exports = __webpack_public_path__ + "static/media/img-perfect-timing@2x.5684a991.png";